var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"jp-tooltip",class:_vm.classes},[_vm._t("default"),(_vm.closeBtn)?_c('button',{staticClass:"closebtn",attrs:{"aria-label":"Close"},on:{"click":function($event){return _vm.$emit('jp-tooltip-close')}}},[_c('FontIcon',{attrs:{"name":"ui_close"}})],1):_vm._e(),_c('div',{class:_vm.triangleClasses})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }